import clsx from "clsx";
import { ReactElement } from "react";

type Props = {
  disabled: boolean;
  onChange(value: number): void;
  value: number;
};

const getThumbColor = (costWeight: number): string => {
  const colors = ["#10b981", "#fbbf24", "#f59e0b", "#ef4444", "#dc2626"];
  return colors[costWeight - 1] || "#10b981";
};

export const SliderInput = ({
  disabled = false,
  onChange,
  value,
}: Props): ReactElement => {
  return (
    <div className="flex items-center space-x-2">
      <input
        className={clsx(
          "slider h-2 flex-1 cursor-pointer appearance-none rounded-lg",
          !disabled && "bg-gray-700",
          disabled && "cursor-not-allowed bg-gray-800",
        )}
        disabled={disabled}
        max="5"
        min="1"
        onChange={(e) => onChange(Number(e.target.value))}
        step="1"
        style={
          {
            "--thumb-color": !disabled ? getThumbColor(value) : "#6b7280",
            background: !disabled
              ? `linear-gradient(to right, #10b981 0%, #fbbf24 25%, #f59e0b 50%, #ef4444 75%, #dc2626 100%)`
              : "#374151",
          } as React.CSSProperties
        }
        type="range"
        value={value}
      />
      <span className="min-w-[2rem] text-center text-sm text-gray-400">
        {value}
      </span>
    </div>
  );
};
